<template>
	<div class="userInfo-user">
		<div class="index-view-top">
			<van-icon @click="toBack" name="arrow-left" size="28" color="#ffffff" />
			<div class="title">{{ $t("head.userInfo") }}</div>
			<van-icon style="opacity: 0" name="ellipsis" size="28" color="#ffffff" />
		</div>
		<div class="details">
			<div class="card">
				<div class="top">{{ $t("userInfo.Head_portrait") }}</div>
				<div class="center">
					<img v-if="userInfo.head" class="header" :src="baseUrl + userInfo.head" alt="" />
					<img v-else class="header" alt="" src="../assets/common.jpg" />
					<img class="bj" @click="imageShow = true" src="../assets/bj.png" alt="" />
				</div>
				<div class="bottom">
					<div>
						<p>{{ $t("userInfo.account") }}</p>
						<p>{{ userInfo.account }}</p>
					</div>
				</div>
			</div>
		</div>
		<van-action-sheet v-model:show="imageShow" :title="$t('userInfo.Choose_picture')">
			<div class="choose-image">
				<div class="image">
					<div @click="selectImage(item)" v-for="(item, index) in imgList" :key='index'>
						<img :class="selectedImage.carouselId == item.carouselId ? 'active' : ''"
							:src="baseUrl + item.img" alt="" />
					</div>
				</div>
				<div class="button-type">
					<div @click="cancel">{{ $t("userInfo.cancel") }}</div>
					<div @click="confirm">{{ $t("userInfo.determine") }}</div>
				</div>
			</div>
		</van-action-sheet>
	</div>
</template>

<script>
import {
	info,
	carousel, editHead
} from "@/utils/request";
import {
	BASEURL
} from "@/utils/http";
export default {
	data() {
		return {
			imageShow: false,
			userInfo: '',
			baseUrl: "",
			imgList: '',//头像列表
			selectedImage: '',//选取中的头像
		};
	},
	mounted() {
		this.getUserInfo();
		this.carousel()
		this.baseUrl = BASEURL
	},
	methods: {
		//取消更换头像
		cancel() {
			this.imageShow = false
			this.selectedImage = ''
		},
		//确认更换头像
		confirm() {
			if (this.selectedImage) {
				editHead({
					head: this.selectedImage.img
				}).then((res) => {
					if (res.code == "200") {
						this.$toast(this.$t("phone.caozuo"));
						this.imageShow = false
						this.getUserInfo()
					} else {
						this.$toast(res.msg);
					}
				});
			} else {
				this.$toast(this.$t("phone.touxiang"));
			}

		},
		//选中头像
		selectImage(item) {
			this.selectedImage = item
		},
		carousel() {
			carousel({
				type: "4"
			}).then((res) => {
				if (res.code == "200") {
					this.imgList = res.data
				}
			});
		},
		getUserInfo() {
			info().then((res) => {
				if (res.code == "200") {
					this.userInfo = res.data;
				}
			});
		},
		toBack() {
			this.$router.push("/user");
		},
	},
};
</script>

<style lang="scss" scoped>
.userInfo-user {
	width: 100vw;
	height: 100vh;
	background: #020017;

	.choose-image {

		.button-type {
			height: 4.0625rem;
			display: flex;
			justify-content: space-around;
			align-items: center;
			border-top: #F8F8F8 0.375rem solid;

			>div:nth-child(1) {
				font-size: 1rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #999999;
			}

			>div:nth-child(2) {
				font-size: 1rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #ffc400;
			}
		}

		.image {
			display: flex;
			align-items: center;
			width: 100%;
			padding: 0 0 1.5625rem;
			overflow-x: scroll;

			>div {
				padding: 0 1rem;

				.active {
					border: 2px solid #FFC400 !important;
				}

				>img {
					border: 2px solid #161414;
					width: 3.875rem;
					height: 3.875rem;
					border-radius: 50%;
				}
			}


		}
	}

	.van-action-sheet {
		background: #ffffff;

		.van-action-sheet__header {
			font-size: 1rem;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #999999;
		}

		.van-action-sheet__close {
			display: none;
		}
	}

	.details {
		padding: 0.9375rem;

		.card {

			border-radius: 0.625rem;
			background-image: url("../assets/zl.png");
			background-position: center center;
			background-size: 100% 100%;
			background-repeat: no-repeat;
			width: 100%;
			background: #161414;

			.top {
				font-size: 0.8125rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #999999;
				padding: 0.9375rem;
			}

			.bottom {
				padding: 0.9375rem;

				>div {
					display: flex;
					align-items: center;
					justify-content: space-between;
					border-top: 0.0625rem solid #272727;
					padding: 0.9375rem 0 0;

					>p:nth-child(1) {
						font-size: 0.8125rem;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #999999;
					}

					>p:nth-child(2) {
						font-size: 0.875rem;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #ffffff;
					}
				}
			}

			.center {
				padding: 0.9375rem;
				display: flex;
				align-items: flex-end;

				.header {
					width: 3.875rem;
					height: 3.875rem;
					border-radius: 50%;
					z-index: 88;
					background: rgba(255, 255, 255, 0.5);
				}

				.bj {
					width: 1.5625rem;
					height: 1.5625rem;
					border-radius: 50%;
					margin-left: -1.5rem;
					z-index: 99;
				}
			}
		}
	}

	.index-view-top {
		height: 3.625rem;
		padding: 0 0.9375rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.title {
			font-size: 1.125rem;
			font-family: PingFang SC-Bold, PingFang SC;
			font-weight: bold;
			color: #ffffff;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/user/userInfo.vue